import script from "./AuthBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AuthBanner.vue?vue&type=style&index=0&id=52a61c3f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a61c3f"]])

export default __exports__